import React, { useState, useEffect } from "react";
import { reviewmodalProps } from "./reviewmodal-interface";
import { Button, Input, Modal } from "antd";
import { createReview } from "../../../api/review/review";
import { useDispatch } from "react-redux";
import { updateUser } from "../../../store/userSlice/userSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { openNotificationWithIcon } from "../../../utils/helper";

const Star = ({ marked, starId }: any) => {
  return (
    <span data-star-id={starId} className="star" role="button">
      {marked ? "\u2605" : "\u2606"}
    </span>
  );
};

const StarRating = ({ value, updateSelection }: any) => {
  //@ts-ignore
  const [rating, setRating] = React.useState(parseInt(value) || 0);
  const [selection, setSelection] = React.useState(0);

  const hoverOver = (event: any) => {
    let val = 0;
    if (event && event.target && event.target.getAttribute("data-star-id"))
      val = event.target.getAttribute("data-star-id");
    setSelection(val);
  };

  useEffect(() => {
    updateSelection(rating);

    // eslint-disable-next-line
  }, [selection]);

  return (
    <div
      onMouseOut={() => hoverOver(null)}
      onClick={(e: any) =>
        setRating(e.target.getAttribute("data-star-id") || rating)
      }
      onMouseOver={hoverOver}
    >
      {Array.from({ length: 5 }, (v, i) => (
        <Star
          starId={i + 1}
          key={`star_${i + 1}`}
          marked={selection ? selection >= i + 1 : rating >= i + 1}
        />
      ))}
    </div>
  );
};

const Reviewmodal = ({ open, closeModal }: reviewmodalProps) => {
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState({
    stars: 0,
    message: "",
  });

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;
  // hooks
  const dispatch = useDispatch();

  const handleRating = (rate: number) => {
    setRating({ ...rating, stars: rate });
  };

  const submitRating = async () => {
    try {
      setLoading(true);
      await createReview(rating);

      dispatch(
        updateUser({
          user: {
            ...user,
            shouldReviewApp: false,
          },
        })
      );
      setLoading(false);
      openNotificationWithIcon(
        "success",
        "Submit Review",
        "You review has been submitted successfully."
      );
      closeModal();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Modal
        closable={false}
        open={open}
        onOk={() => {
          if (!loading) {
            closeModal();
          }
        }}
        onCancel={() => {
          if (!loading) {
            closeModal();
          }
        }}
        footer={null}
      >
        <div className="p-[1.7rem]">
          <p
            className="mb-2 text-center text-[20px] font-semibold leading-[24px]
           text-appcolorpurplefaintone"
          >
            How do you like us now?
          </p>

          <p className="text-base text-center text-appcolorpurplefaintone ">
            Rate your experience on the application so far. Let us know what you
            think.
          </p>

          <div className="mx-auto mt-4 w-[80%]">
            <div>
              <Input.TextArea
                placeholder="Leave us a comment (optional)"
                style={{
                  borderRadius: 8,
                }}
                value={rating.message}
                onChange={(e) => {
                  setRating({ ...rating, message: e.target.value });
                }}
              />
            </div>

            <div className="flex w-[100%] justify-center">
              <StarRating
                value={0}
                updateSelection={(value: any) => {
                  handleRating(value);
                }}
              />
            </div>

            <div className="flex justify-center mt-4">
              <Button
                htmlType="submit"
                className="mr-4 custom-secondary-btn"
                style={{
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                }}
                onClick={() => closeModal()}
              >
                Not Now
              </Button>

              <Button
                htmlType="submit"
                className="custom-primary-btn"
                style={{
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                }}
                loading={loading}
                onClick={() => {
                  console.log(rating);
                  submitRating();
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Reviewmodal;
